import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import { PROJECTS } from "../../data/work";
import { SectionHeading } from "../ui/SectionHeading";
import { CtaLink } from "../ui/CtaLink";
import { Reveal } from "../ui/Reveal";
import { WorkCard } from "../work/WorkCard";
export function FeaturedWork() {
  return <section className="shell section border-t border-line" data-id="element-139" data-mp="qqpremoynz5s">
      <SectionHeading align="split" eyebrow="Featured work" title="Recent builds." lead="Real client case studies will be published here as projects are approved for sharing. These slots are placeholders." action={<CtaLink to="/work" variant="ghost" track="home_work_all" data-id="element-141" data-mp="33rhk7vcjpgu">See all work <ArrowUpRightIcon className="h-4 w-4" data-id="element-142" data-mp="80hwuszbuh17" /></CtaLink>} data-id="element-140" data-mp="c34tr8auus59" />
      <div className="grid gap-[clamp(1rem,1.6vw,2rem)] md:grid-cols-3" data-id="element-143" data-mp="7yx4na0hja6i">
        {PROJECTS.slice(0, 3).map((p, i) => <Reveal key={p.slug} delay={i * 0.05} className="h-full" data-id="element-144" data-mp="3u90zrdd3mzfw" data-mpi={i}>
            <WorkCard project={p} data-id="element-145" data-mp="3uac3xeagi97j" />
          </Reveal>)}
      </div>
    </section>;
}